import { z } from 'zod';
import { BibleLocationSchema } from '../bible/bible-location.js';
/**
 * Bookmark schema - a named location in the Bible
 */
export const BookmarkSchema = BibleLocationSchema.extend({
    name: z.string().min(1),
    isFavorite: z.boolean().optional(),
});
//# sourceMappingURL=bookmark.js.map